import '../scss/chatbot.scss';

const chatbotContainer = document.querySelector('.js-chatbot-container');
const chatButton = document.querySelector('.js-chatbot-open');
const chatbotClose = document.querySelector('.js-chatbot-close');

if (chatbotContainer) {
  if (chatButton) {
    chatButton.addEventListener('click', () => {
      if (chatbotContainer.style.display === 'none' || chatbotContainer.style.display === '') {
        chatbotContainer.style.display = 'flex';
        if (window.innerWidth <= 600) {
          chatButton.style.display = 'none';
        }
      } else {
        chatbotContainer.style.display = 'none';
        if (window.innerWidth <= 600) {
          chatButton.style.display = 'flex';
        }
      }
    });
  }

  if (chatbotClose) {
    chatbotClose.addEventListener('click', () => {
      if (chatbotContainer.style.display === 'none' || chatbotContainer.style.display === '') {
        chatbotContainer.style.display = 'flex';
        if (window.innerWidth <= 600) {
          chatButton.style.display = 'none';
        }
      } else {
        chatbotContainer.style.display = 'none';
        if (window.innerWidth <= 600) {
          chatButton.style.display = 'flex';
        }
      }
    });
  }
}
